
import Enquiry from ".";

export const enquiryRoutes = () => [
  {
    path: "/admin/enquiry",
    title: "Enquiry",
    code: "contactUs",
    layout: "admin",
    routeType: "admin",
    component: Enquiry,
  },
];
